import { Stack, Typography } from '@mui/material';
import * as S from './AuditStatuses.styled';
import { AuditTitlePropsType } from './AuditStatuses.types';
import { Badge } from '../Badge';
import { Stars } from '@mui/icons-material';

export function AuditStatuses(props: AuditTitlePropsType) {
  const { statuses, partnerName, auditUuid, isExamAuditorApproved, isSpecialPartner } = props;

  return (
    <>
      <Stack direction='row' alignItems='center' gap={1} width='100%'>
        {isSpecialPartner && <Badge title='Special partner' icon={<Stars color='primary' />} />}
        <Typography noWrap variant='h5' width='100%'>
          {partnerName}| {auditUuid}
        </Typography>
      </Stack>
      <Stack direction='row' gap={1}>
        {statuses?.needsReview && <S.Chip label='Under Review' />}
        {statuses?.auditOfInterest && <S.Chip label='Audit of Interest' />}
        {isExamAuditorApproved && <S.Chip isSuccess label='Exam Taker Approved' />}
      </Stack>
    </>
  );
}
